import { render, staticRenderFns } from "./Departures.vue?vue&type=template&id=b8755932&scoped=true"
import script from "./Departures.vue?vue&type=script&lang=js"
export * from "./Departures.vue?vue&type=script&lang=js"
import style0 from "./Departures.vue?vue&type=style&index=0&id=b8755932&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8755932",
  null
  
)

export default component.exports